import React from 'react'
import Tooltip from './Tooltip'
import './ui.css'

function FormGroup({ label, required, error, children, htmlFor, className = '', title, hint }) {
  return (
    <div className={'ui-form-group' + (className ? ` ${className}` : '')}>
      {label != null && (
        <label className={'ui-form-group-label' + (required ? ' required' : '')} htmlFor={htmlFor} title={title || undefined}>
          {label}
          {hint && <Tooltip text={hint} />}
        </label>
      )}
      {children}
      {error && <span className="ui-form-group-error">{error}</span>}
    </div>
  )
}

export default FormGroup
